import { render, staticRenderFns } from "./07-WindWaveAnalysis.md?vue&type=template&id=6e877311&"
import script from "./07-WindWaveAnalysis.md?vue&type=script&lang=js&"
export * from "./07-WindWaveAnalysis.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports